<template>
    <div class="animated fadeIn">
        <div v-if="loading">
            <b-row>
                <b-col md="6">
                    <atom-spinner
                        :animation-duration="1000"
                        :size="60"
                        color="#ff1d5e"
                        class="float-right my-4"
                    />
                </b-col>
            </b-row>
        </div>
        <b-row v-if="!loading">
            <b-col>
                <transition name="fade">
                    <b-card
                        border-variant="info"
                        header-bg-variant="primary"
                        header-text-variant="white"
                    >
                        <div slot="header">
                            <span data-font="20">Commission</span>
                            <div class="card-header-actions">
                                <b-link
                                    class="card-header-action btn-minimize"
                                    v-b-toggle.collapse1
                                >
                                    <i
                                        class="icon-arrow-up text-white mt-1"
                                        data-font="20"
                                    ></i>
                                </b-link>
                            </div>
                        </div>
                        <b-row>
                            <b-col md="6"></b-col>
                            <b-col md="3"></b-col>
                            <b-col
                                md="3"
                                v-if="chartData && chartData.allData.length > 0"
                            >
                                <b-card no-body class="bg-info">
                                    <b-card-body class="pb-0">
                                        <h4 class="mb-0">
                                            {{ chartData.formattedData.date }}
                                            :
                                            {{
                                                chartData.formattedData
                                                    .totalAmount
                                            }}
                                        </h4>
                                        <p>Total Current</p>
                                    </b-card-body>
                                </b-card>
                            </b-col>
                        </b-row>

                        <BarChart
                            v-if="chartData && chartData.allData.length > 0"
                            value="Monthly Total Commission"
                            :labelsData="chartData.labels"
                            :chartData="chartData.dataSets"
                            class="mb-2"
                        />

                        <section class="mt-4">
                            <component-new-header
                                title="Transaction History"
                                @search-query="(val) => (filter = val)"
                                :isLoading="loading"
                                @reload-data="getTransactionHistory"
                                :hasCreate="false"
                                :hasExport="true"
                                @onExport="exportData"
                            />
                            <b-card class="card-wrap" border-variant="info">
                                <b-row>
                                    <b-col md="3">
                                        <b-form-group
                                            label-cols-sm="3"
                                            class="mb-0"
                                        >
                                            <label>Time Period</label>
                                            <eb-select
                                                type="select"
                                                v-model="selectedPeriod"
                                                :options="periodList"
                                                label="text"
                                                :id="'selecttime'"
                                                :selected="selectedPeriod"
                                                @input="changePeriod"
                                            ></eb-select>
                                        </b-form-group>
                                    </b-col>

                                    <b-col
                                        md="3"
                                        v-if="userFromTypes.length > 0"
                                    >
                                        <label>Commission From</label>
                                        <eb-select
                                            type="select"
                                            v-model="userFrom"
                                            :options="userFromTypes"
                                            label="text"
                                            :id="'selectuser'"
                                            :selected="userFrom"
                                            @input="getTransactionHistory"
                                        ></eb-select>
                                    </b-col>

                                    <b-col md="2" v-if="userToTypes.length > 0">
                                        <label>Commission To</label>
                                        <eb-select
                                            type="select"
                                            v-model="userTo"
                                            :options="userToTypes"
                                            label="text"
                                            :id="'selectuser'"
                                            :selected="userTo"
                                            @input="getTransactionHistory"
                                        ></eb-select>
                                    </b-col>

                                    <b-col md="2">
                                        <label>Commission Type</label>
                                        <eb-select
                                            type="select"
                                            v-model="selectedcommissionType"
                                            :options="commissionTypes"
                                            label="text"
                                            :id="'selectuser'"
                                            :selected="selectedcommissionType"
                                            @input="getTransactionHistory"
                                        ></eb-select>
                                    </b-col>
                                </b-row>
                                <div>
                                    <b-table
                                        :fields="Columns"
                                        :items="transactionList"
                                        :dark="false"
                                        :filter="filter"
                                        :hover="true"
                                        thead-class="header"
                                        :striped="false"
                                        :bordered="true"
                                        :current-page="currentPage"
                                        :per-page="10"
                                        :small="false"
                                        show-empty
                                        :fixed="false"
                                        :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc"
                                    >
                                        <template
                                            slot="cell(createdAt)"
                                            slot-scope="data"
                                        >
                                            <div>
                                                {{
                                                    data.item.createdAt
                                                        | formatedate
                                                }}
                                            </div>
                                        </template>
                                        <template
                                            slot="paymentResponse.paymentMode"
                                            slot-scope="data"
                                        >
                                            <div>
                                                {{
                                                    data.item.paymentResponse
                                                        .paymentMode
                                                        | formatMode
                                                }}
                                            </div>
                                        </template>
                                        <template slot="cell(empty)">
                                            <div
                                                v-if="loading"
                                                class="text-center"
                                            >
                                                <span>
                                                    <b>Loading...</b>
                                                </span>
                                            </div>
                                            <div v-else class="text-center">
                                                No data available.
                                            </div>
                                        </template>
                                    </b-table>
                                </div>
                                <div style="float: right">
                                    <b-pagination
                                        v-model="currentPage"
                                        :per-page="10"
                                        :total-rows="transactionList.length"
                                        aria-controls="my-table"
                                        prev-text="Prev"
                                        next-text="Next"
                                    ></b-pagination>
                                </div>
                            </b-card>
                        </section>
                    </b-card>
                </transition>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import cTable from "../base/Table.vue";
import MainChartExample from "../dashboard/MainChartExample";
import BarChart from "@/components/chart/BarChart";
import ebSelect from "@/components/FormElements/Select.vue";
import { AtomSpinner } from "epic-spinners";
import moment from "moment";
import ComponentNewHeader from "@/components/componentNewHeader";

export default {
    name: "Commission",
    components: {
        cTable,
        MainChartExample,
        ComponentNewHeader,
        BarChart,
        ebSelect,
        AtomSpinner,
    },
    data: () => {
        return {
            loading: false,
            currentPage: 1,
            userFrom: "",
            userTo: "",
            commissionTypes: ["ALL", "SENT", "RECEIVED"],
            selectedcommissionType: "ALL",
            sortBy: "createdAt",
            sortDesc: true,
            selectedPeriod: {
                text: "Last 7 days",
                value: 7,
            },
            periodList: [
                {
                    text: "Last 7 days",
                    value: 7,
                },
                {
                    text: "Last 15 days",
                    value: 15,
                },
                {
                    text: "Last 30 days",
                    value: 30,
                },
                {
                    text: "Last 3 Months",
                    value: 90,
                },
                {
                    text: "Last 6 Months",
                    value: 180,
                },
            ],
            filter: "",
        };
    },
    computed: {
        Columns() {
            return [
                {
                    key: "invoiceRef",
                    label: "Invoice Ref.",
                    sortable: true,
                },
                {
                    key: "totalAmount",
                    label: "Amount",
                    sortable: true,
                },
                {
                    key:
                        this.$currentUserData.category === "DEALER"
                            ? "commissionedTo.name"
                            : "user.name",
                    label: "UserName",
                },
                {
                    key:
                        this.$currentUserData.category === "DEALER"
                            ? "commissionedTo.userType"
                            : "user.userType",
                    label: "User Type",
                    sortable: false,
                },
                {
                    key: "provider.officeName",
                    label: "Provider Name",
                    sortable: false,
                },
                {
                    key: "user.phone",
                    label: "User Phone",
                    sortable: false,
                },
                {
                    key: "createdAt",
                    label: "Date",
                    sortable: true,
                },
            ];
        },
        transactionList() {
            let dataList =
                this.$store.getters["commission/GetCommissionRuleTransactions"];
            return dataList.sort(
                (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
            );
        },
        chartData() {
            let dataList = this.$store.getters["commission/GetCommissionChart"];
            const labels = [];
            const allData = dataList;
            let formattedData = {
                date: moment(
                    `01-${
                        dataList[0]
                            ? dataList[0].month + "-" + dataList[0].year
                            : "01-2021"
                    }`,
                    "DD-MM-YYYY",
                ).format("MMMM YYYY"),
                totalAmount: dataList[0] ? dataList[0].totalAmount : 0,
            };
            const dataSets = [
                {
                    label: "Monthly Total Commission",
                    fill: true,
                    borderColor: "#f87979",
                    backgroundColor: "#f87979",
                    pointBorderColor: "#249EBF",
                    borderWidth: 3,
                    data: [],
                },
            ];

            if (dataList.length > 0) {
                let lastKnownTime = "01-01-1900";
                const minCols = 12;
                dataList.reverse().map((x) => {
                    labels.push(`${x.month}-${x.year}`);
                    lastKnownTime = `01-${x.month}-${x.year}`;
                    dataSets[0].data.push(
                        +parseFloat(x.totalAmount).toFixed(2),
                    );
                });
                if (dataSets[0].data.length < minCols) {
                    lastKnownTime = moment(`01-${labels}`, "DD-MM-YYYY");
                    Array(minCols - dataSets[0].data.length)
                        .fill(0)
                        .map((_, i) => {
                            labels.unshift(
                                lastKnownTime
                                    .add(-1, "month")
                                    .format("MM-YYYY"),
                            );
                            dataSets[0].data.unshift(0.0);
                        });
                }
            }
            return {
                labels,
                datasets: dataSets,
                formattedData,
                allData,
            };
        },
        userFromTypes() {
            let userData = this.$currentUserData;
            if (this.$userRole === "Tenant") {
                this.userFrom = "DEALER";
                return ["DEALER", "DISTRIBUTOR"];
            } else if (userData.category === "DISTRIBUTOR") {
                this.userFrom = "DEALER";
                return ["DEALER"];
            } else if (userData.category === "DEALER") {
                this.userFrom = "";
                return [];
            }
        },
        userToTypes() {
            let userData = this.$currentUserData;
            if (this.$userRole === "Tenant") {
                this.userTo = "";
                return [];
            } else if (userData.category === "DISTRIBUTOR") {
                this.userTo = "";
                return [];
            } else if (userData.category === "DEALER") {
                this.userTo = "DISTRIBUTOR";
                return ["TENANT", "DISTRIBUTOR"];
            }
        },
    },
    methods: {
        changePeriod(event) {
            this.getTransactionHistory();
        },
        getTransactionHistory() {
            this.loading = true;
            let payload = {
                days: this.selectedPeriod.value,
                user: this.$currentUserData._id,
                commissionFrom: this.userFrom,
                commissionTo: this.userTo,
                commission: this.selectedcommissionType,
            };
            this.$store
                .dispatch("commission/getCommissionTransactionList", payload)
                .then((data) => {
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        exportData() {
            let datalist = [];
            this.transactionList.map((obj) => {
                datalist.push({
                    invoiceRef: obj.invoiceRef,
                    totalAmount: obj.totalAmount,
                    UserName:
                        this.$currentUserData.category === "DEALER"
                            ? obj.commissionedTo.name
                            : obj.user.name,
                    UserType:
                        this.$currentUserData.category === "DEALER"
                            ? obj.commissionedTo.userType
                            : obj.user.userType,
                    UserPhone: obj.user.phone,
                    Provider_Name: obj.provider ? obj.provider.officeName : "",
                    Date: moment(String(obj.createdAt)).format(
                        "DD/MM/YYYY hh:mm A",
                    ),
                });
            });
            this.exportAsCSV(datalist, "commissiontransactions");
        },
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY hh:mm A");
            }
        },
    },
    async mounted() {
        this.loading = true;
        await this.getTransactionHistory();
        await this.$store.dispatch("commission/getCommissionChart", {});
        this.loading = false;
    },
};
</script>

<style scoped></style>
